import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import "../../newcomponents/index.css"
//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import Header from "./Header"
import { changeSidebarType } from "store/actions"
import { useSelector } from "react-redux"

const Sidebar = props => {
  const mode = useSelector(state => state.Layout.layoutMode)
  const { leftSideBarType, dispatch, isMobile } = props
  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile))
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile))
    }
  }

  return (
    <React.Fragment>
      <Header
        toggleMenuCallback={toggleMenuCallback}
        leftSideBarType={leftSideBarType}
      />

      <div
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
        }}
        className="vertical-menu sidebar"
      >
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {},
)(withRouter(withTranslation()(Sidebar)))
